import { FaLinkedin, FaTwitter } from "react-icons/fa"


export const Team = (props) => {
  return (
    <div id='team' className='text-center'>
      <div className='container'>
        <div>
          <h2>The Team</h2>
          <h4>
            Two colleagues who have worked together in the development of video games set out to tell the adventure of the founder of this society, seeking the help of the members to complete the story and get the legendary greyhounds.
          </h4>
          <div id='row' className="img-group">
            {props.data ? props.data.map((d, i) => (
              <div key={`${d.name}-${i}`}>
                {renderTeamMember(d)}
              </div>
            )) : 'loading'}
          </div>
        </div>
      </div>
    </div>
  )
}

const clickHandler = (url) => {
  window.open(url)
}

const renderTeamMember = (memberData) => {
  const name = memberData.name
  const img = memberData.img
  const jobPosition = memberData.job
  const linkedinUrl = memberData.linkedinUrl
  const twitterUrl = memberData.twitterUrl

  return (
    <div className='thumbnail'>
      {' '}
      <img src={img} style={{size: 50}} alt='...' className='team-img' />
      <div className='caption'>
        <h4>{name}</h4>
        <p>{jobPosition}</p>
        <div>
          <FaLinkedin style={{ cursor: "pointer", marginRight: 10 }} size={25} onClick={() => clickHandler(linkedinUrl)} />
          <FaTwitter style={{ cursor: "pointer", marginLeft: 10, color: '00ACEE' }} size={25} onClick={() => clickHandler(twitterUrl)} />
        </div>
      </div>
    </div>
  )
}
